import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3acea9e1&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acea9e1",
  null
  
)

export default component.exports